var _circle, _circle2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoInfoS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    stroke: "#C8C9CC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.9999,
    cy: 3.6,
    r: 0.6,
    fill: "#C8C9CC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.3999,
    y: 5,
    width: 1.2,
    height: 4,
    fill: "#C8C9CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfoS);
export default __webpack_public_path__ + "static/media/ico_info_s.9a1d9708f9da75826b04acb5490bd8a0.svg";
export { ForwardRef as ReactComponent };